import React from 'react'
import PropTypes from 'prop-types'
import {
  SourceQueryDisplay,
  TablesDisplay,
  ColumnsDisplay,
  PredicatesDisplay,
  PaginationDisplay
} from '../configurationDisplay'

function PurposeDetailPanel ({ purposeCode, purposeData }) {
  if (!purposeCode || !purposeData) {
    return (
      <div style={{
        padding: '32px',
        textAlign: 'center',
        color: 'var(--text-color-subtle)',
        paddingLeft: '32px'
      }}
      >
        <p>Select a purpose to view details</p>
      </div>
    )
  }

  return (
    <div style={{ paddingLeft: '24px', overflowY: 'auto' }}>
      <div style={{ marginBottom: '16px' }}>
        <h3 style={{ marginBottom: '4px' }}>{purposeData.displayName}</h3>
        <div style={{ fontSize: '0.875rem', color: 'var(--text-color-subtle)' }}>
          Purpose Code: {purposeCode}
        </div>
      </div>

      <SourceQueryDisplay sourceQuery={purposeData.sourceQuery} />
      <TablesDisplay tables={purposeData.tables} />
      <ColumnsDisplay columns={purposeData.columns} />
      <PredicatesDisplay
        masterPredicate={purposeData.masterPredicate}
        subordinatePredicates={purposeData.subordinatePredicates}
      />
      <PaginationDisplay pagination={purposeData.pagination} />
    </div>
  )
}

PurposeDetailPanel.propTypes = {
  purposeCode: PropTypes.string,
  purposeData: PropTypes.object
}

export default PurposeDetailPanel
